import { faRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Input, Text, TextButton } from '@modusign/design-system';
import { useState } from 'react';
import { useDebounce } from 'react-use';

import { ResourceRoleSubject } from '../../types';
import countSummary from '../../utils/countSummary';
import isEqualResourceRoleSubject from '../../utils/isEqualResourceRole';
import AuthorizedResourceRoleSummary from '../AuthorizedResourceRoleSummary';
import SearchedMemberGroupTab from '../SearchedMemberGroupTab';

interface ResourceRoleSelectListProps {
  value: ResourceRoleSubject[];
  onChange: (value: ResourceRoleSubject[]) => void;
}

export default function ResourceRoleSelectList({ value, onChange }: ResourceRoleSelectListProps) {
  const [input, setInput] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');

  useDebounce(() => setSearchKeyword(input), 300, [input]);

  const summary = countSummary(value);

  return (
    <Flex flexDirection="column">
      <div>
        <Text fontWeight="medium" whiteSpace="pre">
          선택한{' '}
        </Text>
        <AuthorizedResourceRoleSummary
          groupCount={summary.group}
          isActive
          memberCount={summary.member}
        />
      </div>
      <Input
        mt={4}
        placeholder="이름 또는 이메일로 찾기"
        value={input}
        onBlur={() => setSearchKeyword(input)}
        onChange={(e) => setInput(e.target.value)}
      />
      <Flex justifyContent="space-between" mb={4} mt={7}>
        {searchKeyword ? (
          <>
            <Text fontWeight="medium">{`'${searchKeyword}' 검색 결과`}</Text>
            <TextButton
              onClick={() => {
                setInput('');
                setSearchKeyword('');
              }}
            >
              <FontAwesomeIcon icon={faRotateLeft} style={{ marginRight: '2px' }} />
              검색 초기화
            </TextButton>
          </>
        ) : (
          <Text fontWeight="medium">전체 멤버·그룹</Text>
        )}
      </Flex>
      <SearchedMemberGroupTab
        keyword={searchKeyword}
        selectedSubjects={value}
        onToggle={(role) => {
          const filteredSelected = value.filter((r) => !isEqualResourceRoleSubject(r, role));

          // not selected before
          if (filteredSelected.length === value.length) {
            onChange([...value, role]);
          } else {
            onChange(filteredSelected);
          }
        }}
      />
    </Flex>
  );
}
